import styled from "styled-components";
import { ProfileCashierButtonDefaultBox } from "./profile-cashier-button.default.box";
import {baseColors} from "../../../../themes/definitions/casino777/base-colors";

export const ProfileCashierButtonCasino777Box = styled(ProfileCashierButtonDefaultBox)`
    border-radius: 5px;

    color: ${baseColors.base03};
    border-color: ${baseColors.base03};
    padding: 1rem 4rem 1rem 1rem;
    line-height: 1;
    opacity: 1;
    font-size: 15px;
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        padding: 0.5rem 3.2rem 0.5rem 0.5rem;
    }
    ${({theme}) => theme.font.presets.body};
`;
